<template>
  <div :class="t.wrapper">
    <label :class="t.label">
      {{ question.prompt }}
      <span v-if="!question.required" class="text-gray-400 font-normal">(optional)</span>
    </label>
    <p
      v-if="question.subtext"
      :class="t.subtext"
      v-html="question.subtext"
    ></p>
    <input
      v-model="answer"
      type="email"
      inputmode="email"
      autocomplete="email"
      :class="[t.input, error ? 'border-red-500' : 'border-gray-300']"
      :style="inputFocusStyle"
      @focus="handleFocus"
      @blur="handleBlur"
      placeholder="email@example.com"
    />
    <p v-if="error" :class="t.error">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
import { tokensFor } from './size_tokens';

export default {
  name: 'QuestionEmail',
  props: {
    question: {
      type: Object,
      required: true,
    },
    existingAnswer: {
      type: Object,
      default: null,
    },
    size: {
      type: String,
      default: 'kiosk',
      validator: (v) => ['kiosk', 'form'].includes(v),
    },
  },
  data() {
    return {
      answer: '',
      originalAnswer: '',
      error: false,
      errorMessage: 'Please enter a valid email address.',
      isFocused: false,
    };
  },
  computed: {
    t() {
      return tokensFor(this.size);
    },
    inputFocusStyle() {
      if (this.isFocused) {
        return {
          borderColor: 'var(--team-primary)',
          boxShadow: '0 0 0 3px rgba(var(--team-primary-rgb, 55, 65, 81), 0.1)',
        };
      }
      return {};
    },
    dirty() {
      return this.answer !== this.originalAnswer;
    },
    valid() {
      if (this.question.required) {
        return this.isValidEmail(this.answer);
      }
      // If not required, empty is valid, but if filled must be valid email
      if (this.answer.length === 0) return true;
      return this.isValidEmail(this.answer);
    },
  },
  watch: {
    answer() {
      this.emit();
      if (this.valid) {
        this.error = false;
      }
    },
  },
  created() {
    if (this.existingAnswer && this.existingAnswer.answer) {
      this.answer = this.existingAnswer.answer;
      this.originalAnswer = this.existingAnswer.answer;
    }
    this.$notificationManager?.on('show-reg-errors', this.validate);
  },
  destroyed() {
    this.$notificationManager?.off('show-reg-errors', this.validate);
  },
  methods: {
    isValidEmail(email) {
      if (!email || email.length === 0) return false;
      // Basic email regex
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    emit() {
      this.$emit('answer-changed', this.question, this.answer, this.dirty, this.valid);
    },
    validate() {
      if (!this.valid) {
        this.error = true;
        if (this.question.required && this.answer.length === 0) {
          this.errorMessage = 'Please enter an email address.';
        } else {
          this.errorMessage = 'Please enter a valid email address.';
        }
      } else {
        this.error = false;
      }
    },
    handleFocus() {
      this.isFocused = true;
    },
    handleBlur() {
      this.isFocused = false;
      this.validate();
    },
  },
};
</script>
